import { render, staticRenderFns } from "./BreakingNewsWidget.vue?vue&type=template&id=37fab848&scoped=true&"
import script from "./BreakingNewsWidget.vue?vue&type=script&lang=js&"
export * from "./BreakingNewsWidget.vue?vue&type=script&lang=js&"
import style0 from "./BreakingNewsWidget.vue?vue&type=style&index=0&id=37fab848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fab848",
  null
  
)

export default component.exports